<template>
  <div class="w-full">
    <div class="px-10 pt-6 pb-6">
      <p class="text-zt-xl text-zt-dark-500">
        {{ $t('message.DownloadAllDocuments.downloadInProgress') }}
      </p>
      <p class="text-zt-xl text-zt-dark-500">
        {{ $t('message.DownloadAllDocuments.discardDownload') }}
      </p>
    </div>
    <div class="w-full bg-zt-dark-200 py-2 flex pr-6 rounded-b">
      <div class="ml-auto">
        <button
          data-vs-button="close-cancel-modal"
          class="focus:outline-none mr-3 text-zt-dark-400 font-medium"
          @click="closeModal"
        >
          {{ $t('message.DownloadAllDocuments.cancel') }}
        </button>
        <button
          data-vs-button="close-success-modal"
          class="focus:outline-none bg-zt-primary-200 text-white font-medium download--success px-2"
          @click="cancelDownload"
          :disabled="buttonDisable"
        >
          {{ $t('message.DownloadAllDocuments.yesDownload') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadInitialized',
  inject: ['closeModal', 'cancelDownload'],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    buttonDisable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.download--success {
  height: 34px;
  border-radius: 4px;
  background-color: var(--branding-primary, --v-primary-base);
  border: 1px solid var(--branding-primary, --v-primary-base);
}
</style>
